import type { OnboardingDescriptionDto } from "app/pages/sales-intelligence/sub-modules/onboarding/types/OnboardingDescription.dto";
import type { OnboardingWizardAnswer } from "app/pages/sales-intelligence/sub-modules/onboarding/types/OnboardingWizardAnswer.dto";
import type { SidebarHubTasksDto } from "app/pages/sales-intelligence/sub-modules/onboarding/types/SidebarHub";
import type { IFetchService } from "app/services/fetchService";
import type { PostConfigObject } from "app/services/fetchService";
import { SALES_API_BASE_URL } from "app/pages/sales-intelligence/constants/api";
import type { IActivationAgentFormDTO } from "app/pages/sales-intelligence/modules/onboarding/types/form-value";

export default function createOnboardingApiService(fetchService: IFetchService) {
    return {
        fetchOnboardingDescription(): Promise<OnboardingDescriptionDto> {
            return fetchService.get(`${SALES_API_BASE_URL}/onboarding/description`);
        },

        sendWizardResult(params: OnboardingWizardAnswer): Promise<void> {
            return fetchService.post(`${SALES_API_BASE_URL}/onboarding/submit-answer`, params);
        },

        fetchHubTasks(): Promise<SidebarHubTasksDto> {
            return fetchService.get(`${SALES_API_BASE_URL}/onboarding/tasks`);
        },
        fetchOnboardingInitData(): Promise<OnboardingInitData> {
            return fetchService.get(`${SALES_API_BASE_URL}/ai-activation-agent/initial-info`);
        },
        fetchOnboardingSignalsInfoData(): Promise<OnboardingSignalsInfoData> {
            return fetchService.get(`${SALES_API_BASE_URL}/ai-activation-agent/signals-info`);
        },
        submitActivationAgentForm(form: IActivationAgentFormDTO, config?: PostConfigObject): Promise<void> {
            return fetchService.post(`${SALES_API_BASE_URL}/ai-activation-agent/submit`, form, config);
        },
    };
}
